$(document).ready(function () {
    $('.js-visibility_parent').each(function () {
        var parent = $(this);
        var children = parent.find('.js-visibility_children');
        var threshold = 5;
        var buttonText = '';
        var button = $(`
      <button
      class="button button_secondary button_secondary--show button_secondary--s-small button--icon-more fw-700 t-sm b-m"
      type="button"
      >
          <span class="b-xxs">${buttonText}</span>
            <svg class="icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.187 6.71a.2.2 0 01-.03-.28l.686-.86a.2.2 0 01.281-.031l4.25 3.4a.2.2 0 00.25 0l4.251-3.4a.2.2 0 01.281.031l.687.86a.2.2 0 01-.03.28l-5.188 4.15a.2.2 0 01-.25 0L3.187 6.71z" fill="currentColor"/>
            </svg>
      </button>
      `);
        var remainingChildrenCount = children.length - threshold;

        if (children.length > threshold) {
            children.slice(threshold).hide();
            buttonText = `Show ${remainingChildrenCount} more`;
            button.find('span').text(buttonText);
            parent.append(button);
        } else {
            button.remove();
        }

        button.on('click', function () {
            children.slice(threshold).toggle();
            button.toggleClass('active');
            var buttonText = button.text();
            if (button.hasClass('active')) {
                buttonText = `Show less`;
            } else {
                buttonText = `Show ${remainingChildrenCount} more`;
            }
            button.find('span').text(buttonText);
        });
    });
});
